'use strict';
function SiteDir(
	$scope,
	$stateParams,
	$window,
	$location,
	$timeout,
	auth,
	pmtAlertService,
	pmtSideBarCollapsedService,
	pmtElmService,
	pmtSiteInfoService,
	$i18next
) {
	let $ctrl = this;
	$ctrl.alertBox = pmtAlertService.alertBox;
	$ctrl.alertShowAccountNotAccess = false;
	$ctrl.alertShowUserNotAccess = false;
	$ctrl.collapsed = false;
	$ctrl.workInProgressCount = 0;

	$ctrl.elmNavApp =
		($window.location.pathname || '').split('/')[3] === 'usersettings' ||
		($window.location.pathname || '').split('/')[3] === 'user'
			? 'UserSettings'
			: 'Navigation';

	const setSplitViewClass = () => {
		$timeout(() => {
			$ctrl.collapsed = pmtSideBarCollapsedService.get();
		});
	};
	setSplitViewClass();

	const parseSubscription = subscription => {
		if (Notification.permission === 'denied') {
			return { status: 'Denied' };
		}

		if (!subscription) {
			return { status: 'NotAsked' };
		}
		return { status: 'Granted', subscription: subscription };
	};

	const getCurrentPushSubscription = () => {
		if (
			!('Notification' in window) ||
			!('PushManager' in window) ||
			!('serviceWorker' in navigator)
		) {
			return Promise.resolve({ status: 'Unsupported' });
		}

		return navigator.serviceWorker.ready.then(sw =>
			sw.pushManager.getSubscription().then(parseSubscription)
		);
	};

	const pinMeToPushRegistration = () =>
		window.PinMeToPushRegistration
			? Promise.resolve(window.PinMeToPushRegistration)
			: Promise.reject('PinMeToPushRegistration not available');

	const ensureSavedSubscription = subscription => {
		if (subscription && subscription.status === 'Granted' && subscription.subscription) {
			return pinMeToPushRegistration().then(pmt => pmt.saveSubscription(subscription.subscription));
		} else {
			return Promise.resolve();
		}
	};

	const chatSubscriptions = [
		{
			/**
			 *
			 * @function pmtCrisp.sendFeedback is located at:
			 *  ../ui/src/PinMeTo/pmt-crisp.js
			 *
			 *  > Ports are located in:
			 *  ../ui/src/PinMeTo/Global/TopNavigation.elm
			 */

			id: 'PinMeToUiSupportTicket',
			f: ticketData => {
				pmtCrisp.sendFeedback(ticketData, res => {
					pmtElmService.sendData(
						`${$ctrl.elmNavApp}.Main`,
						`in_${$ctrl.elmNavApp}_Main_PinMeToUiSupportTicketResponse`,
						res
					);
				});
			}
		},
		{
			id: 'PinMeToUiToggleChat',
			f: () => {
				pmtCrisp.toggle();
			}
		},
		{
			id: 'PinMeToUiInitChat',
			f: user => {
				pmtCrisp.init(user, res => {
					pmtElmService.sendData(
						`${$ctrl.elmNavApp}.Main`,
						`in_${$ctrl.elmNavApp}_Main_PinMeToUiInitChatResponse`,
						res
					);
				});
			}
		}
	];

	$ctrl.topNavSubscriptions = [
		...chatSubscriptions,
		{
			id: 'PinMeToUiToggleDemo',
			f: () => {
				const isDemo = localStorage.getItem('isDemo') || 'false';
				localStorage.setItem('isDemo', isDemo === 'false' ? 'true' : 'false');
				location.reload();
			}
		}
	];
	$ctrl.userSettingsSubscriptions = [
		...chatSubscriptions,
		{
			id: 'languageChanged',
			f: lng => {
				$i18next.i18n.changeLanguage(lng);
			}
		},
		{
			id: 'sidebarCollapsed',
			f: data => {
				pmtSideBarCollapsedService.set(data.collapsed);
				setSplitViewClass();
			}
		},
		{
			id: 'registerPush',
			f: () => {
				const pmt = window.PinMeToPushRegistration;
				if (pmt && pmt.registerPush) {
					pmt
						.registerPush()
						.then(parseSubscription)
						.then(subscription => {
							if (subscription) {
								pmtElmService.sendData(
									'UserSettings.Main',
									'in_UserSettings_Main_pushSubscriptionChanged',
									subscription
								);
							}
						});
				}
			}
		},
		{
			id: 'getCurrentPushSubscription',
			f: () => {
				getCurrentPushSubscription().then(subscription => {
					return ensureSavedSubscription(subscription).then(() => {
						pmtElmService.sendData(
							'UserSettings.Main',
							'in_UserSettings_Main_pushSubscriptionChanged',
							subscription
						);
					});
				});
			}
		}
	];

	$scope.$on('$locationChangeStart', () => {
		if ($ctrl.elmNavApp === 'UserSettings') {
			pmtElmService.sendData(
				'UserSettings.Main',
				'in_UserSettings_Main_urlChange',
				$location.absUrl()
			);
		} else {
			pmtElmService.sendData(
				'Navigation.Sidebar.Main',
				'in_Navigation_Sidebar_Main_urlChange',
				$location.absUrl()
			);
		}
	});

	pmtSiteInfoService.subscribeToWork(function (work) {
		$timeout(() => {
			$ctrl.workInProgressCount = work.inProgress || 0;
			pmtElmService.sendData(
				'Navigation.Sidebar.Main',
				'in_Navigation_Sidebar_Main_workInProgressCount',
				work.inProgress || 0
			);
		}, 0);
	});

	pmtSiteInfoService.subscribeToWork(function (msg) {
		if (msg && msg.work) {
			$timeout(function () {
				pmtElmService.sendData(
					'Conflicts.Main',
					msg.work.success ? 'in_Conflicts_Main_workSucceeded' : 'in_Conflicts_Main_workFailed',
					msg.work.id
				);
			});
		}
	});

	const { canAccessLabelsDevUi } = require('../../../../../modules/locationLabels/labelsFeatureFlagged.mts');

const setArgs = function (user, localAccess, productUrl) {
		const siteName = (user.selectedSite && user.selectedSite.name) || '';
		const userSites = Object.keys(user.accountAccess);

		if (!userSites.includes(siteName) && user.isAdmin) {
			$window.location.reload();
			return Promise.resolve();
		}
		$ctrl.args = {
			user: user,
			productUrl: productUrl,
			permissions: {
				roles: localAccess.roles,
				groups: user.localAccess.groups,
				permissions: localAccess.permissions,
				locations: user.localAccess.locations ? [...user.localAccess.locations.values()] : []
			},
			collapsed: pmtSideBarCollapsedService.get(),
			env: $window.pmtEnv,
			currentRoute: $location.path(),
			currentUrl: $location.absUrl()
		};

		pmtElmService.sendData(`${$ctrl.elmNavApp}.Main`, `args_${$ctrl.elmNavApp}`, $ctrl.args);
		setSplitViewClass();

		$ctrl.listingsSidebarSubscriptions = [
			{
				id: 'sidebarCollapsed',
				f: data => {
					pmtSideBarCollapsedService.set(data.collapsed);
					setSplitViewClass();
				}
			}
		];

		$ctrl.listingsSidebar = {
			siteName: $stateParams.site,
			siteDisplayName: user.selectedSite ? user.selectedSite.displayName : '',
			currentUrl: $location.absUrl(),
			collapsed: pmtSideBarCollapsedService.get(),
			workInProgressCount: $ctrl.workInProgressCount,
			permissions: {
				roles: localAccess.roles,
				groups: user.localAccess.groups,
				permissions: localAccess.permissions,
				locations: [...user.localAccess.locations.values()]
			},
			enabledInsights: {
				google: user?.selectedSite?.analytics?.google?.enabled ?? false,
				facebook: user?.selectedSite?.analytics?.facebook?.enabled ?? false,
				bing: user?.selectedSite?.analytics?.bing?.enabled ?? false,
				apple: user?.selectedSite?.analytics?.apple?.enabled ?? false,
				here: user?.selectedSite?.analytics?.here?.enabled ?? false,
				tomtom: user?.selectedSite?.analytics?.tomtom?.enabled ?? false,
				baidu: user?.selectedSite?.analytics?.baidu?.enabled ?? false,
				factual: user?.selectedSite?.analytics?.factual?.enabled ?? false,
				trustpilot: user?.selectedSite?.analytics?.trustpilot?.enabled ?? false,
				overture: user?.selectedSite?.analytics?.overture?.enabled ?? false,
				ptv: user?.selectedSite?.analytics?.ptv?.enabled ?? false
			},
			apiEnabled: user?.selectedSite?.places?.api?.enabled ?? false,
			mediaReviewEnabled: user?.selectedSite?.places?.feature?.allowMediaReview?.enabled,
			bulkVerifiedEligible: user.selectedSite.bulkVerifiedEligible || false,
			isDemoMode: localStorage.getItem('isDemo') === 'true' || false,
			enabledNetworks: {
				google: user?.selectedSite?.analytics?.google?.enabled ?? false,
				facebook: user?.selectedSite?.analytics?.facebook?.enabled ?? false,
				bing: user?.selectedSite?.analytics?.bing?.enabled ?? false,
				apple: user?.selectedSite?.analytics?.apple?.enabled ?? false,
				here: user?.selectedSite?.analytics?.here?.enabled ?? false,
				tomtom: user?.selectedSite?.analytics?.tomtom?.enabled ?? false,
				baidu: user?.selectedSite?.analytics?.baidu?.enabled ?? false,
				factual: user?.selectedSite?.analytics?.factual?.enabled ?? false,
				trustpilot: user?.selectedSite?.analytics?.trustpilot?.enabled ?? false,
				overture: user?.selectedSite?.analytics?.overture?.enabled ?? false,
				ptv:
					(!user?.selectedSite?.places?.feature?.allowPtvTwoWay?.enabled &&
						user?.selectedSite?.analytics?.ptv?.enabled) ??
					false,
				ptv2way:
					(user?.selectedSite?.analytics?.ptv?.enabled &&
						user?.selectedSite?.places?.feature?.allowPtvTwoWay?.enabled) ??
					false
			},
			appleOauthEnabled: user?.selectedSite?.analytics?.apple?.connectionType === 'oauth',
			isLabelsFeatureFlaggedUser: canAccessLabelsDevUi({
				email: user.email,
				isDemo: user.isDemo,
				isOwner: localAccess.roles.includes('owner')
			})
		};

		if (user?.selectedSite && $ctrl.elmNavApp === 'Navigation') {
			$ctrl.reconnectNetworkArgs = {
				siteName: $stateParams.site,
				userIsOwner: localAccess.roles.includes('owner'),
				user: user,
				productName: 'Listings',
				appleEnabled: user?.selectedSite?.analytics?.apple?.enabled ?? false,
				appleOAuth: user?.selectedSite?.analytics?.apple?.connectionType === 'oauth'
			};
		}

		return Promise.resolve();
	};

	auth.getUser($stateParams.site).then(function (user) {
		const baseUrl = $window.pmtEnv.urls.listings;
		const siteName = (user.selectedSite && user.selectedSite.name) || '';

		const productUrl =
			$ctrl.elmNavApp === 'UserSettings' ? baseUrl + siteName + '/user' : baseUrl + siteName;

		const localAccess = { ...user.localAccess };
		localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
		localAccess.permissions = localAccess.permissions ? [...localAccess.permissions.values()] : [];
		const user_ = { ...user, localAccess: localAccess };

		setArgs(user_, localAccess, productUrl).catch(err => console.error(err));
	});
}

angular.module('pmtPlacesApp.controllers').component('pmtSiteDir', {
	templateUrl: 'components/placesApp/pmtSiteDir.html',
	controller: SiteDir
});

SiteDir.$inject = [
	'$scope',
	'$stateParams',
	'$window',
	'$location',
	'$timeout',
	'auth',
	'pmtAlertService',
	'pmtSideBarCollapsedService',
	'pmtElmService',
	'pmtSiteInfoService',
	'$i18next'
];
